var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"text-nowrap px-4 px-md-4 w-100",class:{ maxLength: _vm.titleFullLength },attrs:{"variant":"outline-secondary","href":_vm.doc?.url,"size":"sm","pill":"","target":"_blank","title":_vm.doc?.title,"alt":_vm.doc?.title}},[_vm._v("\n  "+_vm._s(_vm.doc?.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }